module.exports = __webpack_public_path__ + "static/media/cert_91.b6451a9f.jpg";